import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BanquetBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BANQUET;
}

export default BanquetBuildingTileEntity;
